import { useState } from "react"
import {gallic} from "../../../../data/gallic"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const Gallic = (props) => {

    const selectList = gallic.map(gal => ({
        id:gal.id,
        name:gal.name,
        wood:gal.wood,
        clay:gal.clay,
        iron:gal.iron,
        crop:gal.crop,
        all: gal.wood + gal.clay + gal.crop + gal.iron
    }) )

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function vypis() {
        const selectedGal = selectList[selectValue-1]
        props.addItem(selectedGal)
    }

return (
    <div>
        <ListSelect label="...choose trop..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    )
}
export default Gallic
